module.exports = __webpack_public_path__ + "img/img1.a2fb7073.png";